import styled from 'styled-components';

export const MenuHeaderSection = styled.header.attrs(props => ({
  id: props.id || 'header',
}))`
  position: fixed; /* Keep header fixed while scrolling */
  top: 0;
  left: 0;
  width: auto;
  z-index: 2000;
  pointer-events: none;
  background: transparent; /* remove any header line/background */
  text-align: left;
  padding: 10px 20px;

  .headerContainer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .menuclick img {
  width: 60px;
  height: 60px;
  cursor: pointer;
  z-index: 2100;
  pointer-events: auto;
  
  /* Combined animations */
  animation:
    float 2s ease-in-out infinite alternate,
    neonPulse 1.5s infinite alternate,
    colorShift 3s infinite alternate;
  
  transition: transform 0.3s;
}

.menuclick img:hover {
  transform: scale(1.4) rotate(10deg);
  filter: drop-shadow(0 0 20px #0ff) drop-shadow(0 0 30px #0ff);
}

/* Float up and down */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); } /* bigger movement */
}

/* Neon glow pulse */
@keyframes neonPulse {
  0% { filter: drop-shadow(0 0 5px #0ff); }
  50% { filter: drop-shadow(0 0 20px #0ff) drop-shadow(0 0 35px #0ff); }
  100% { filter: drop-shadow(0 0 10px #0ff); }
}

/* Color shift for extra “cyberpunk vibe” */
@keyframes colorShift {
  0% { filter: hue-rotate(0deg); }
  25% { filter: hue-rotate(60deg); }
  50% { filter: hue-rotate(120deg); }
  75% { filter: hue-rotate(180deg); }
  100% { filter: hue-rotate(360deg); }
}


  .overlay {
    position: fixed;
    height: 100%;
    width: 0;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.95);
    overflow-x: hidden;
    transition: width 0.5s ease;
    z-index: 2000;
    pointer-events: none;
  }

  .overlay.open {
    width: 100%;
    pointer-events: auto;
  }

  .overlay-content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 25px;
    pointer-events: auto;
  }

  .overlay-content a {
    font-size: 2rem;
    color: #0ff;
    text-decoration: none;
    position: relative;
    animation: neonMove 2s infinite alternate ease-in-out;
  }

  .overlay-content a:hover {
    color: #ff0;
    text-shadow:
      0 0 5px #ff0,
      0 0 10px #ff0,
      0 0 20px #0ff,
      0 0 30px #0ff;
  }

  @keyframes neonMove {
    0% { transform: translateX(0) translateY(0) rotate(0deg); }
    20% { transform: translateX(1px) translateY(-1px) rotate(-1deg); }
    40% { transform: translateX(-1px) translateY(2px) rotate(1deg); }
    60% { transform: translateX(2px) translateY(-2px) rotate(-1deg); }
    80% { transform: translateX(-2px) translateY(1px) rotate(1deg); }
    100% { transform: translateX(1px) translateY(0) rotate(0deg); }
  }

  .close-btn {
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 2rem;
    color: #0ff;
    cursor: pointer;
    transition: 0.3s;
  }

  .close-btn:hover {
    color: #ff0;
  }

  @media screen and (max-width: 480px) {
    .overlay-content a {
      font-size: 1.5rem;
    }

    .close-btn {
      font-size: 1.8rem;
    }
  }
`;
